
@if(toastPackage.title === "error"){
    <div class="toast fade show align-items-center text-white border-0 bg-danger mb-2"
    role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                {{ toastPackage.message | translate}}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 mx-auto mt-2"></button>
        </div>
    </div>
}
@else if(toastPackage.title === "success") {
    <div class="toast fade show align-items-center text-white border-0 bg-success mb-2"
    role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                {{ toastPackage.message | translate}}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 mx-auto mt-2"></button>
        </div>
    </div>
}
@else {
    <div class="toast fade show align-items-center text-white border-0 bg-light-blue mb-2"
    role="alert" aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                {{ toastPackage.message | translate}}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 mx-auto mt-2"></button>
        </div>
    </div>
}
